// extracted by mini-css-extract-plugin
module.exports = {"slider":"PeriodSliderGray_slider__32qkv","value":"PeriodSliderGray_value__1gEEN","step":"PeriodSliderGray_step__XJI9x"};